import 'styled-components/macro';
import React, { useMemo } from 'react';
import { Button } from '@harver/shared-ui';
import { HelpIcon } from '@harver/shared-ui/lib/icons';

import { useWindowSize } from '../../hooks/useWindowSize';

type Props = {
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    testId?: string;
};

export const HelpButton: React.FC<Props> = ({ testId = 'header.helpButton', onClick }) => {
    const { width: windowWidth } = useWindowSize();
    const isMobileScreen = useMemo(() => windowWidth < 768, [windowWidth]);

    return isMobileScreen ? (
        <Button
            css={{
                // Adding pointer-events back
                pointerEvents: 'auto',
            }}
            variant="icon"
            color="transparent"
            testId={testId}
            onClick={onClick}
        >
            <HelpIcon />
        </Button>
    ) : (
        <Button
            css={{
                // Adding pointer-events back
                pointerEvents: 'auto',
            }}
            variant="contained"
            testId={testId}
            startIcon={<HelpIcon />}
            onClick={onClick}
        >
            Help
        </Button>
    );
};
